module.exports = __webpack_public_path__ + "static/img/main_img.99d09616.png";